<!-- 关于我们 -->
<template>
  <div class="about_Us">
    <Breadcrumb style="margin-top: 20px;margin-left: 160px;color: rgb(110, 114, 117);">
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem to="/about_Us">关于我们</BreadcrumbItem>
    </Breadcrumb>
    <div class="gywm">关于我们</div>
    <div class="total ">
        <div class="left"></div>
        <div class="right">
          <div class="right1">          
          </div>
          <div class="right2">宝妈灵活就业网</div>
          <div class="right3">全国首个面向育儿妈妈的灵活就业创业平台</div>
          <div class="right4"></div>
          <div class="right5">公司成立于2019年11月，由灵活科技公司投资控股，高管组建合伙人企业入股；</div>
          <div class="right6">以“让每个放学回家的孩子，都能吃上妈妈做的热饭”为使命，以“朝九晚四（早上9点上班，下午4点下班）”为产品特质，目标是以珠三角为中心，凝聚并打造中国孩子3-12岁（幼儿园到小学）的5000万育儿妈妈的灵活就业门户；并开发平台结算工具灵活宝；</div>
          <div class="right7">项目具有巨大和深远的社会公益意义，利国利民！项目一经推出，就得到了政府、妇联、媒体和社会各界的高度关注和支持，时任广州市分管领导签呈要求在全广州市推广，广东电视台、广州日报、南方人物周刊均予以大幅报道，项目启动当年被评选为黄埔区“我为群众办实事”十大民生项目，并被写入黄埔区政府工作报告。</div>
        </div>
    </div>
    <div class="dixian"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="less" scoped>
@import "./about_Us.less";
</style>
